import { useState, useEffect } from "react";
import Crumb from "../../includes/crumb/Crumb";

function AccountDeletion(props) {
  useEffect(() => {
    document.title = "Beenonvi | Supprimer mon compte";
    return () => {
      document.title = "";
    };
  }, []);
  return (
    <main className="main">
      <Crumb pageRoute="/account-deletion" pageName="Supprimer mon compte" />
      <section className="privacy">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2 className="h2 mt-4 mb-4">
                Procédure de suppression de compte Nonvi Voyage Plus
              </h2>
              <p>BLOLAB PRO, développeur officiel de l'application Nonvi Voyage Plus</p>
              <p>
                Sur Nonvi Voyage Plus, vous pouvez demander la suppression de votre compte à tout
                moment. Voici les options disponibles :
              </p>

              <h4 className="h4 mt-4">Option 1 : Via l'application mobile</h4>
              <ol style={{ paddingBottom: "20px" }}>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Accédez aux menus dans la sidebar de l'application.
                </li>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Sélectionnez &lt;&lt;Supprimer mon compte&gt;&gt;.
                </li>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Cliquer sur &lt;&lt;Continuer&gt;&gt;.
                </li>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Renseigner votre mot de passe et cliquez sur &lt;&lt;Confirmer
                  la suppression&gt;&gt;.
                </li>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Un message de confirmation s’affichera, indiquant que la
                  suppression prendra effet sous 30 jours maximum.
                </li>
              </ol>

              <h4 className="h4 mt-4">Option 2 : Par e-mail</h4>
              <p>
                Envoyez votre demande de suppression de compte à l’adresse :{" "}
                <a href="mailto:dpo@beenonvi.bj">dpo@beenonvi.bj</a> en
                précisant :
              </p>
              <ul style={{ paddingBottom: "20px" }}>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  Vos nom, prénom, numéro de téléphone, code client et adresse
                  e-mail associée au compte.
                </li>
                <li style={{ listStyle: "initial", paddingLeft: 0, marginLeft: "30px" }}>
                  La mention “Demande de suppression de compte – Nonvi Voyage
                  Plus” dans l’objet du message.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AccountDeletion;
